import { forwardRef, useEffect, useRef, useState } from "react";
import SpinnerFullScreen from "../../components/SpinnerFullScreen";
import { Card, CardContent, Snackbar, TextField, Typography } from "@mui/material";
import MuiAlert, { AlertProps } from "@mui/material/Alert";
import {
  appColor,
  constants,
  EndPoint,
  messages,
} from "../../common/constants";
import LocatesKpi from "../../components/LocateKpi";
import moment from "moment";
import { serviceAPIMapping } from "../../config/service-api-mapping";
import axios from "axios";
import _ from "lodash";
import { getDivHeight } from "../../common/commonFunctions";
import TabContext from "@mui/lab/TabContext";
import TabPanel from "@mui/lab/TabPanel";
import { Box, Tab, styled } from "@mui/material";
import { Icon } from "@iconify/react";
import MuiTabList, { TabListProps } from "@mui/lab/TabList";
import LocateAdders from "../../components/LocateAdders";
import LocatesGrid from "../../components/LocatesGrid";
import PreBorrowGrid from "../../components/PreBorrowGrid";
import MostLocatesGrid from "../../components/MostLocatedGrid";
import React from "react";
import EnquiryGrid from "../../components/EnquiryGrid";
import { isServiceHealthy } from "../../utils/API";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";

const TabList = styled(MuiTabList)<TabListProps>(({ theme }) => ({
  borderBottom: "0 !important",
  "&, & .MuiTabs-scroller": {
    boxSizing: "content-box",
    padding: theme.spacing(1.25, 1.25, 2),
    margin: `${theme.spacing(-1.25, -1.25, -2)} !important`,
  },
  "& .MuiTabs-indicator": {
    display: "none",
  },
  "& .Mui-selected": {
    boxShadow: theme.shadows[2],
    backgroundColor: `${appColor}`,
    color: `${theme.palette.common.white} !important`,
  },
  "& .MuiTab-root": {
    lineHeight: 1,
    borderRadius: theme.shape.borderRadius,
    "&:hover": {
      color: `${appColor}`,
    },
  },
}));

const LocateClient = () => {
  const [snackbarMessage, setSnackbarMessage] = useState<any>("");
  const [doShowFullScreenLoader, setDoShowFullScreenLoader] =
    useState<boolean>(false);
  const [open, setOpen] = useState(false);
  const [locateKPI, setLocateKPI] = useState<any>([]);
  let accountId = window.localStorage.getItem("activeAccountCode");
  const [date, setDate] = useState(moment().toDate());
  const [isInitialRefresh, setIsInitialRefresh] = useState(true);
  const [selectedTab, setSelectedTab] = useState<string>("Enquiry");
  const tabListRef = useRef(null);
  const [isLocatesRefreshed, setIsLocatesRefreshed] = useState<boolean>(false);
  const [isPreBorrowsRefreshed, setIsPreBorrowsRefreshed] =
    useState<boolean>(false);
  const [isMostLocatedRefreshed, setIsMostLocatedRefreshed] =
    useState<boolean>(false);

  const [showTotalRow, setShowTotalRow] = useState(true);

  const [currentGridRef, setCurrentGridRef] = useState<any>(null);
  const [currentGridApi, setCurrentGridApi] = useState<any>(null);
  const [selectedRow, setSelectedRow] = useState<any>(null);
  const [newRows, setNewRows] = useState<any>(null);
  const [selectedRows, setSelectedRows] = useState<any>([]);
  const [hideLocateKpi, setHideLocateKpi] = useState<any>(true);
  const [locateHeight, setLocateHeight] = useState<any>("");
  const [selectedTickerCode, setSelectedTickerCode] = useState<any>(null);
  const [locateRequest, setLocateRequest] = useState<any>(null);
  const [isInquiriesRefreshed, setIsInquiriesRefreshed] =
    useState<boolean>(false);
    const [sourceFilter, setSourceFilter] = useState(null);
      const [statusFilter, setStatusFilter] = useState(null);
  // const [preBorrowRequest, setPreBorrowRequest] = useState<any>(null)
  const [enableSocketUpdates, setEnableSocketUpdates] = useState<boolean>(true);
  const refreshIntervals = [
    { label: "5 sec", value: 5000 },
    { label: "10 sec", value: 10000 },
    { label: "15 sec", value: 15000 },
    { label: "5 min", value: 300000 },
    { label: "10 min", value: 600000 },
    { label: "15 min", value: 900000 },
    { label: "Off", value: 0 },
  ];
  const [currentInterval, setCurrentInterval] = useState(5000);
  const activeClientShortName = window?.localStorage?.getItem(
    "activeClientShortName"
  );
  const [isShowFilledLocates, setIsShowFilledLocates] =
          useState<boolean>(false);

  const Alert = forwardRef<HTMLDivElement, AlertProps>(function Alert(
    props,
    ref
  ) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });

  const handleClose = (
    event?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === constants.clickaway) {
      return;
    }

    setOpen(false);
  };

  const getLocatesKPI = async () => {
    try {
      setLocateKPI([]);
      const request = {
        date: moment(date).format("YYYY-MM-DD"),
        account: accountId,
        clientShortCode: activeClientShortName,
      };

      const token = window.localStorage.getItem("refreshtoken");
      const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      };

      await axios
        .post(
          `${serviceAPIMapping["LOCATEMANAGEMENT-SERVICE"].apiRouteURL}${EndPoint.getLocateKPI}`,
          JSON.stringify(request),
          {
            headers: headers,
          }
        )
        .then(async (response: any) => {
          if (response?.status === 200) {
            const rows = await response?.data;
            if (rows && _.isArray(rows) && rows?.length > 0) {
              setLocateKPI(rows);
            } else {
              setLocateKPI([]);
            }
          } else if (response?.status === 401) {
            //logout(channel)
          } else {
            setLocateKPI([]);
          }
        });
    } catch (err) {
      setLocateKPI([]);
    }
  };

  useEffect(() => {
    if (!isInitialRefresh && date && !_.isUndefined(date)) {
      getLocatesKPI();
    }
  }, [date]);

  useEffect(() => {
    if (isInitialRefresh) {
      getLocateServiceHealth()
      setIsInitialRefresh(false);
    }
  }, [isInitialRefresh]);

  const refreshLocates = () => {
    setIsLocatesRefreshed(!isLocatesRefreshed);
    getLocatesKPI?.();
  };

  const refreshPreBorrows = () => {
    setIsPreBorrowsRefreshed(!isPreBorrowsRefreshed);
    getLocatesKPI?.();
  };

  const refreshMostLocated = () => {
    setIsMostLocatedRefreshed(!isMostLocatedRefreshed);
    getLocatesKPI?.();
  };

  const handleChange = (event: any, newValue: string) => {
    setSelectedTab(newValue);
    setSelectedRow(null);
    setNewRows([]);
  };

  const getCardHeight = (extraSpace: number = 0) => {
    const kpiHeight = document?.getElementById("locate-kpi-id")?.offsetHeight;
    const divHeight = _.isUndefined(kpiHeight) ? 22 : kpiHeight + 265;
    return window?.innerWidth > 999
      ? "calc(100vh - " + (divHeight + extraSpace) + "px)"
      : "60vh";
  };

  const getMLCardHeight = (extraSpace: number = 0) => {
    const kpiHeight = document?.getElementById("locate-kpi-id")?.offsetHeight;
    const divHeight = _.isUndefined(kpiHeight)
      ? 22
      : kpiHeight + (selectedTab === "Most Located" ? 230 : 420);
    return window?.innerWidth > 999
      ? "calc(100vh - " + (divHeight + extraSpace) + "px)"
      : "70vh";
  };

  const insertNewRow = (rows: any) => {
    if (selectedTab === "Locates") {
      const data = rows?.map((row: any) => {
        return {
          ...row,
          centpershare: _.isNaN(row?.centpershare)
            ? ""
            : row?.centpershare?.toFixed(4),
          centpershare_appr: _.isNaN(row?.centpershare_appr)
            ? ""
            : row?.centpershare_appr?.toFixed(4),
          rebate: !_.isNaN(row?.rebate) ? (+row?.rebate)?.toFixed(4) : "",
        };
      });
      
      setNewRows(data);
      getLocatesKPI();
    }
    else if(selectedTab === "Enquiry"){

        const data = rows?.map((row: any) => {
        return {
          ...row,
          requested_time: moment(row.requested_time).format('HH:mm:ss'),
          response_time: moment(row.response_time).format('HH:mm:ss')
        };
      })
      setNewRows(data);
      getLocatesKPI();
    }
    else {
      setNewRows(rows);
      getLocatesKPI();
    }
  };

  useEffect(() => {
    const height = getCardHeight();
    setLocateHeight(height);
  }, [hideLocateKpi]);

  useEffect(() => {
    const height = getCardHeight();
    setLocateHeight(height);
  }, []);

  useEffect(() => {
    if (selectedTab === "Pre Borrow") {
      setSelectedTickerCode(selectedRow?.sec_id);
    } else if (selectedTab === "Locates") {
      setSelectedTickerCode(
        _.isUndefined(selectedRow?.ticker)
          ? selectedRow?.secid
          : selectedRow?.ticker
      );
      
    } else {
      setSelectedTickerCode(selectedRow?.ticker);
    }
  }, [selectedRow]);

  const refreshInquiries = () => {
    setIsInquiriesRefreshed(!isInquiriesRefreshed);
    getLocatesKPI?.();
  };

  const toggleRealTimeData = () => {
    setEnableSocketUpdates(!enableSocketUpdates);
  };

  const getLocateServiceHealth = async () => {
      await isServiceHealthy(
        `${serviceAPIMapping["LOCATEMANAGEMENT-SERVICE"].apiRouteURL}/${EndPoint.actuator}`
      ).then((response: any) => {
        if (!response?.ok || response?.status === 503) {
          setSnackbarMessage(`Locate${messages.serviceDownMessage}`);
          setOpen(true);
        } else {
          getLocatesKPI();
        }
      });
    };

  return (
    <>
      <Snackbar open={open} onClose={handleClose}>
        <Alert
          onClose={handleClose}
          severity="error"
          sx={{
            width: "100%",
            backgroundColor: "orange",
            textDecorationColor: "white",
          }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
      {doShowFullScreenLoader && <SpinnerFullScreen />}
      <div className="col p-0 mx-auto w-100">
        <div className="d-flex flex-row justify-content-between align-items-center">
          <div
            className="row mx-auto title-subHeaderTitle dtc-title justify-content-start"
            style={{ height: "1.5rem" }}
          >
            Locates Client Dashboard
          </div>
          <div
            className="d-flex justify-content-end me-3 align-items-center"
            aria-disabled
          >
            <div className="d-flex flex-row justify-content-between me-2 align-items-bottom">
              <div className={`mt-1 me-2`}>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                          <DatePicker
                            disableFuture
                            openTo="day"
                            className="onFocusOutTermDateID"
                            views={["year", "month", "day"]}
                            maxDate={moment().toDate()}
                            value={date}
                            inputFormat="yyyy-MM-dd"
                            InputProps={{
                              notched: false,
                              style: { fontSize: 13, color: "#212529" },
                            }}
                            onChange={(newValue: any) => {
                              setDate(newValue);
                            }}
                            renderInput={(params: any) => (
                              <TextField
                                variant="outlined"
                                sx={{
                                  "& .MuiInputBase-input": {
                                    height: "0.4rem",
                                    padding: "12px 10px 12px",
                                  },
                                  "& .MuiInputAdornment-root": {
                                    marginLeft: "0px",
                                  },
                                }}
                                className={`locate-kpi-date-picker ${
                                  moment().isAfter(date, "day") ? "past-date-bg" : ""
                                }`}
                                {...params}
                              />
                            )}
                          />
                        </LocalizationProvider>
                      </div>
              <div className="me-2 auto-complete-padding py-1">
                <select
                  className="locates-select"
                  value={currentInterval}
                  disabled={enableSocketUpdates}
                  onChange={(e: any) => {
                    setCurrentInterval(e?.target?.value);
                  }}
                >
                  {refreshIntervals?.map((interval: any) => {
                    return (
                      <>
                        <option
                          className="locates-select"
                          key={interval?.value}
                          value={interval?.value}
                        >
                          {interval?.label}
                        </option>
                      </>
                    );
                  })}
                </select>
              </div>
              <div className="form-check form-switch d-flex align-self-center">
                <input
                  checked={enableSocketUpdates}
                  onChange={() => toggleRealTimeData()}
                  className="form-check-input me-2"
                  type="checkbox"
                  role="switch"
                  id="flexSwitchCheckDefault"
                  title="Turn on/off real time data"
                />
                <label
                  className="form-check-label text-nowrap mb-0 align-self-center"
                  style={{ fontSize: "small" }}
                  htmlFor="flexSwitchCheckDefault"
                  title="Turn on/off real time data"
                >
                  Real Time Data
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="w-100" id="locate-kpi-id">
          <Card sx={{ backgroundColor: hideLocateKpi ? "" : "#ffffff00" }}>
            <CardContent className="py-0 d-flex flex-row">
              {locateKPI && !hideLocateKpi && (
                <LocatesKpi
                  kpiData={locateKPI}
                  setDate={(date: any) => {
                    setDate(date);
                  }}
                  isAdmin={false}
                />
              )}

              {!hideLocateKpi && (
                <Icon
                  icon={"ep:arrow-up-bold"}
                  className="ms-3 d-flex justify-content-end pe-0 cursor-pointer"
                  onClick={() => setHideLocateKpi(!hideLocateKpi)}
                ></Icon>
              )}

              {hideLocateKpi && (
                <>
                  <div className="d-flex flex-row justify-content-between w-100">
                    <Typography className="ms-2 d-flex justify-content-start pe-0">
                      Locate KPI
                    </Typography>
                    <Icon
                      icon={"ep:arrow-down-bold"}
                      className="ms-3 d-flex justify-content-end pe-0 cursor-pointer"
                      onClick={() => setHideLocateKpi(!hideLocateKpi)}
                    ></Icon>
                  </div>
                </>
              )}
            </CardContent>
          </Card>
        </div>
        <div className="w-100 mt-1" style={{ height: locateHeight }}>
          <Card>
            <CardContent className="w-100 p-1">
              <div style={{ height: "100%" }} className="w-100 pt-1">
                <TabContext value={selectedTab}>
                  <div
                    className="h-100"
                    id="locate-tabs"
                    style={{ boxSizing: "border-box" }}
                  >
                    <TabList
                      variant="scrollable"
                      id="locate-tab-list"
                      ref={tabListRef}
                      scrollButtons="auto"
                      onChange={handleChange}
                      aria-label="locate-tab-list"
                      sx={{ boxSizing: "border-box" }}
                    >
                      <Tab
                        value="Enquiry"
                        className="py-0 my-0"
                        sx={{ minHeight: "30px" }}
                        label={
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              minHeight: "30px",
                              ...{ "& svg": { mr: 2 } },
                            }}
                          >
                            <Icon fontSize="1.25rem" icon="tabler:search" />
                            {"Inquiry"}
                          </Box>
                        }
                      />
                      <Tab
                        value="Locates"
                        className="py-0 my-0"
                        sx={{ minHeight: "30px" }}
                        label={
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              minHeight: "30px",
                              ...{ "& svg": { mr: 2 } },
                            }}
                          >
                            <Icon fontSize="1.25rem" icon="tabler:user" />
                            {"Locates"}
                          </Box>
                        }
                      />
                      <Tab
                        value="Pre Borrow"
                        className="py-0 my-0"
                        sx={{ minHeight: "30px" }}
                        label={
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              minHeight: "30px",
                              ...{ "& svg": { mr: 2 } },
                            }}
                          >
                            <Icon fontSize="1.25rem" icon="tdesign:money" />
                            {"Pre Borrow"}
                          </Box>
                        }
                      />
                      <Tab
                        value="Most Located"
                        className="py-0 my-0"
                        sx={{ minHeight: "30px" }}
                        label={
                          <Box
                            className="py-0 my-0"
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              minHeight: "30px",
                              ...{ "& svg": { mr: 2 } },
                            }}
                          >
                            <Icon fontSize="1.25rem" icon="tabler:users" />
                            {"Most Located"}
                          </Box>
                        }
                      />
                    </TabList>
                  </div>
                  {(selectedTab === "Enquiry" ||
                    selectedTab === "Locates" ||
                    selectedTab === "Pre Borrow") && (
                    <hr className="mt-1 mb-1" />
                  )}

                  <div
                    className="w-100 sm-md-overflow-x"
                    id="locate-adder"
                    style={{
                      height: getDivHeight(
                        "locate-tab-list",
                        selectedTab === "Most Located" ||
                          selectedTab === "Inventory"
                          ? 20
                          : 55
                      ),
                    }}
                  >
                    <LocateAdders
                      refreshLocates={refreshLocates}
                      refreshPreBorrows={refreshPreBorrows}
                      refreshMostLocated={refreshMostLocated}
                      selectedTab={selectedTab}
                      currentGridRef={currentGridRef}
                      isAdmin={false}
                      selectedTicker={selectedTickerCode}
                      currentGridApi={currentGridApi}
                      date={date}
                      insertNewRow={insertNewRow}
                      selectedRows={selectedRows}
                      inquiryLocateRequest={locateRequest}
                      refreshInquiries={refreshInquiries}
                      onToggleTotalRow={(showRow: boolean) => setShowTotalRow(showRow)}
                      onShowFilledLocates={(isShow: boolean)=>{setIsShowFilledLocates(isShow)}}
                       applyLocateSourceFilter={(filters: any) => {
                        setSourceFilter(filters);
                      }}
                      applyLocateStatusFilter={(filters: any) => {
                        setStatusFilter(filters);
                      }}
                    />
                    <TabPanel
                      className="w-100 p-1 locate-panel"
                      value="Enquiry"
                      style={{ height: getCardHeight(-40) }}
                    >
                      <EnquiryGrid
                        type="enquiry"
                        getBtnRef={(gridRef: any) => {
                          setCurrentGridRef(gridRef);
                        }}
                        onRowSelect={(row: any) => {
                          setSelectedRow(row);
                        }}
                        isInquiriesRefreshed={isInquiriesRefreshed}
                        onLocate={(row: any) => {
                          setLocateRequest(row);
                        }}
                        date={date}
                        newRows={newRows}
                        enableSocketUpdates={enableSocketUpdates}
                        currentInterval={currentInterval}
                        isAdmin={false}
                        getGridApi={(gridApi: any) => {
                            setCurrentGridApi(gridApi);
                        }}
                        sourceFilter={sourceFilter}
                        statusFilter={statusFilter}
                      />
                    </TabPanel>

                    <TabPanel
                      className="w-100 p-1 locate-panel"
                      value="Locates"
                      style={{ height: locateHeight }}
                    >
                      <div style={{ height: locateHeight }}>
                        <LocatesGrid
                          isAdmin={false}
                          isLocatesRefreshed={isLocatesRefreshed}
                          getBtnRef={(gridRef: any) => {
                            setCurrentGridRef(gridRef);
                          }}
                          onRowSelect={(row: any) => {
                            setSelectedRow(row);
                          }}
                          getGridApi={(gridApi: any) => {
                            setCurrentGridApi(gridApi);
                          }}
                          date={date}
                          newRows={newRows}
                          setSelectedRows={(rows: any) => setSelectedRows(rows)}
                          enableSocketUpdates={enableSocketUpdates}
                          currentInterval={currentInterval}
                          showTotalRow={showTotalRow}
                          sourceFilter={sourceFilter}
                          statusFilter={statusFilter}
                        />
                      </div>
                    </TabPanel>
                    <TabPanel
                      className="w-100 p-1 locate-panel"
                      value="Pre Borrow"
                      style={{ height: getCardHeight() }}
                    >
                      <PreBorrowGrid
                        isPreBorrowsRefreshed={isPreBorrowsRefreshed}
                        getBtnRef={(gridRef: any) => {
                          setCurrentGridRef(gridRef);
                        }}
                        onRowSelect={(row: any) => {
                          setSelectedRow(row);
                        }}
                        getGridApi={(gridApi: any) => {
                          setCurrentGridApi(gridApi);
                        }}
                        date={date}
                        newRows={newRows}
                        isAdmin={false}
                        enableSocketUpdates={enableSocketUpdates}
                        currentInterval={currentInterval}
                      />
                    </TabPanel>
                    <TabPanel
                      className="w-100 p-1 locate-panel-most-locates"
                      value="Most Located"
                      style={{ height: getMLCardHeight(-20) }}
                    >
                      <MostLocatesGrid
                        isMostLocatesRefreshed={isMostLocatedRefreshed}
                        getBtnRef={(gridRef: any) => {
                          setCurrentGridRef(gridRef);
                        }}
                        getGridApi={(gridApi: any) => {
                          setCurrentGridApi(gridApi);
                        }}
                        date={date}
                        isLocateTab={false}
                        isAdmin={false}
                        isShowFilledLocates={isShowFilledLocates}
                      />
                    </TabPanel>
                  </div>
                </TabContext>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </>
  );
};

export default LocateClient;
